module.exports = __webpack_public_path__ + "static/img/subscription_package_yellow.b89991c1.png";